import * as React from "react";

import Container from "@mui/material/Container";
import { Button, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { AiOutlineDown } from "react-icons/ai";

import settings from "../../Images/settings.png";
import timer from "../../Images/timer.png";
import swapicon from "../../Images/swapicon.png";
import usdt from "../../Images/usdt.png";
import eth from "../../Images/eth.png";
import Footer from "../../Sections/Footer/Index";

import { Link } from "react-router-dom";

import Navbar from "../../Sections/Navbar/Index";

import Minumum from "../../Components/Minmium/Minumum";
import TokensDialogOne from "../../Components/Dialogs/TokensDialogOne";
import TokensDialogTwo from "../../Components/Dialogs/TokensDialogTwo";

const { useState } = React;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Exchange = () => {
  // for dialog
  const [opendialog, setOpendialog] = React.useState(false);
  const [useSelectedValue, setSelectedValue] = React.useState("USDT");
  const [useSelectedImg, setSelectedImg] = React.useState(usdt);

  const handleClickOpen = () => {
    setOpendialog(true);
  };
  const handleListItemClick = (value) => {
    setOpendialog(false);
    setSelectedImg(value.logoURI);
    setSelectedValue(value.symbol);
  };
  // for dialog

  // for dialog2
  const [opendialog2, setOpendialog2] = React.useState(false);
  const [useSelectedValue2, setSelectedValue2] = React.useState("ETH");
  const [useSelectedImg2, setSelectedImg2] = React.useState(eth);
  const [useFirstVal, setFirstVal] = React.useState();
  const [useSecondVal, setSecondVal] = React.useState();
  const [useInputSlipage, setInputSlipage] = React.useState("2.0");

  const handleClickOpendialog2 = () => {
    setOpendialog2(true);
  };

  const handleListItemClick2 = (value2) => {
    setOpendialog2(false);
    setSelectedImg2(value2.logoURI);
    setSelectedValue2(value2.symbol);
  };

  // for dialog2

  const [toggle, setToggle] = useState(true);
  const toggleChecked = () => setToggle((toggle) => !toggle);

  const [showResults, setShowResults] = React.useState(false);
  const firstInput = (event) => {
    const val = event.target.value;
    setFirstVal(val);
    setShowResults(true);
  };
  const SecondInput = (event) => {
    const val = event.target.value;
    setSecondVal(val);
    setShowResults(true);
  };
  const handleSlipage = (event) => setInputSlipage(event.target.value);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openrec, setOpenrec] = React.useState(false);
  const handleOpenrec = () => setOpenrec(true);
  const handleCloserec = () => setOpenrec(false);

  const [value, setValue] = React.useState(0);

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Navbar />
      <Container>
        <div className="forheight">
          <Grid container justifyContent="center">
            <Grid xs={12} sm={11} md={6} className="py-5">
              <div className=" pt-sm-3 d-flex justify-content-center">
                <div className="Ray---Connectpage---Card">
                  <div className="px-3 pt-3 Ray---Connect---Button---border">
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Tab
                          label="Exchange"
                          {...a11yProps(0)}
                          className="Ray---Connect--tab-btn"
                        />

                        <Link
                          className="Ray---Connect--tab-btn1"
                          style={{ textDecoration: "none" }}
                          to="./liquidity"
                        >
                          <Tab label="Liquidity" {...a11yProps(1)} />
                        </Link>
                      </Tabs>
                    </Box>
                  </div>
                  <div className="px-3 pb-3">
                    <TabPanel value={value} index={0}>
                      <div className="Ray__Connect__Exchange pt-3">
                        Exchange
                        <p className="Ray---connect---swap">swap token</p>
                      </div>
                      <div className="Ray__Connect__Icons pt-3">
                        <img onClick={handleOpen} src={settings} />
                        <img
                          className="ml-2"
                          onClick={handleOpenrec}
                          src={timer}
                        />
                      </div>
                      <div
                        className="Ray---Connect---Modal---fromto mb-2"
                        style={{ color: "white" }}
                      >
                        From
                      </div>
                      <br />
                      <TokensDialogOne
                        open={opendialog}
                        onClose={handleListItemClick}
                        disabling={useSelectedValue}
                      />
                      {toggle ? (
                        <div className="inputfield">
                          <input
                            onChange={firstInput}
                            className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                            type="number"
                            placeholder="0.00"
                            value={useFirstVal}
                          />
                          <a className="alink" onClick={handleClickOpen}>
                            <img
                              className="Ray---Exchange---Dialoglogo"
                              src={useSelectedImg}
                            />
                            {useSelectedValue}
                            <span style={{ padding: "0px 0px 0px 8px" }}>
                              <AiOutlineDown />
                            </span>
                          </a>
                        </div>
                      ) : (
                        <div className="inputfield">
                          <input
                            onChange={SecondInput}
                            className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                            type="number"
                            placeholder="0.00"
                            value={useSecondVal}
                          />
                          <a className="alink" onClick={handleClickOpendialog2}>
                            <img
                              className="Ray---Exchange---Dialoglogo"
                              src={useSelectedImg2}
                            />
                            {useSelectedValue2}

                            <span style={{ padding: "0px 0px 0px 8px" }}>
                              <AiOutlineDown />
                            </span>
                          </a>
                        </div>
                      )}
                      <div className="Ray---Connect---Swapbutton">
                        <img
                          style={{ height: 30 }}
                          onClick={toggleChecked}
                          src={swapicon}
                        />
                      </div>
                      <div
                        className="Ray---Connect---Modal---fromto mb-2"
                        style={{ color: "white" }}
                      >
                        To
                      </div>
                      <TokensDialogTwo
                        opendialog2={opendialog2}
                        onClosedialog2={handleListItemClick2}
                        disablingtoken={useSelectedValue2}
                      />
                      {toggle && (
                        <div className="inputfield">
                          <input
                            onChange={SecondInput}
                            className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                            type="number"
                            placeholder="0.00"
                            value={useSecondVal}
                          />
                          <a className="alink" onClick={handleClickOpendialog2}>
                            <img
                              className="Ray---Exchange---Dialoglogo"
                              src={useSelectedImg2}
                            />
                            {useSelectedValue2}

                            <span style={{ padding: "0px 0px 0px 8px" }}>
                              <AiOutlineDown />
                            </span>
                          </a>
                        </div>
                      )}
                      {!toggle && (
                        <div className="inputfield">
                          <input
                            onChange={firstInput}
                            className="Ray---Connect---Modal---SelectToken---Fieldforsearchtest"
                            type="number"
                            placeholder="0.00"
                            value={useFirstVal}
                          />
                          <a className="alink" onClick={handleClickOpen}>
                            <img
                              className="Ray---Exchange---Dialoglogo"
                              src={useSelectedImg}
                            />
                            {useSelectedValue}
                            <span style={{ padding: "0px 0px 0px 8px" }}>
                              <AiOutlineDown />
                            </span>
                          </a>
                        </div>
                      )}

                      <div className="Ray---Connect---Slipage mt-4">
                        <p>slippage tolrence</p>
                      </div>
                      <div className="Ray---Connect---Slipagepercent mt-4">
                        {useInputSlipage} %
                      </div>
                      <Button className="Rey---Connect---SwapButton py-4 my-1">
                        Swap
                      </Button>
                      {showResults ? <Minumum /> : null}
                    </TabPanel>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {/* Modal for recent starts here -----------------------------------------*/}
        <Modal
          className=" Modal"
          open={openrec}
          onCloserec={handleCloserec}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Recent Transactions
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleCloserec(false)}
                >
                  X
                </button>
              </h4>

              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecentboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Send</h6>
                  <h6>-50 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span style={{ fontWeight: 300, color: "white" }}>
                    Jan 10 To: 0X024...1E61
                  </span>
                  <span style={{ fontWeight: 300, color: "white" }}>
                    {" "}
                    +50 Gxs
                  </span>
                </div>
              </div>
              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecent2ndboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Recieved</h6>
                  <h6> +500 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span style={{ fontWeight: 300, color: "white" }}>
                    Jan 10 To: 0X024...1E61
                  </span>
                  <span style={{ fontWeight: 300, color: "white" }}>
                    {" "}
                    +500 Gxs
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Footer />
        {/* Modal for settings starts here------------------------------------------ */}

        <Modal
          className="Modal"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Setting
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleClose(false)}
                >
                  X
                </button>
              </h4>
              <div
                className="Ray---Connect---Modal---fromto"
                style={{ color: "white" }}
              >
                <p>Slipage Tolerance?</p>
                <div className="Ray---settings---inputauto">
                  <Button className="Rey---settings---autobutton">auto</Button>

                  <label htmlFor="text"></label>
                  <input
                    onChange={handleSlipage}
                    className="Ray---Connect---Modal---Text "
                    type="number"
                    placeholder="2.00%"
                    value={useInputSlipage}
                  />
                </div>

                <p className="mt-2 pb-2">Transaction Deadline?</p>

                <p className="Ray---Connect---Modal---TextTransaction">20</p>
                <p className="Ray---Connect---Modal---textmint">Minutes</p>
              </div>
            </div>
          </div>
        </Modal>
      </Container>
    </div>
  );
};

export default Exchange;
